<template>
  <div class="pagination-container">
    <el-pagination
      class="pagination"
      :pager-count="pageCount"
      layout="jumper, prev, pager, next"
      :current-page.sync="localCurrentPage"
      :page-size="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
    ></el-pagination>
    <span class="special">共{{ total }}条，每页{{ pageSize }}条</span>
  </div>
</template>

<script>
export default {
  props: {
    // 数据总条目数
    total: {
      type: Number,
      default: 0
    },
    // 每页多少条
    pageSize: {
      type: Number,
      default: 20
    },
    // 当前所在页面
    currentPage: {
      type: Number,
      default: 1
    },
    // 最多显示的页码
    pageCount: {
      type: Number,
      default: 7
    }
  },
  data() {
    return {
      localCurrentPage: this.currentPage
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.localCurrentPage = this.currentPage;
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      let options = {
        currentPage: val
      };
      this.$emit("queryChange", options);
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.pagination-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(96, 98, 102, 1);
  .special {
    height: 34px;
    padding-top: 18px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    letter-spacing: 2pt;
  }
}
</style>
